(function() { window.GUID_5b25af20_114a_4a3d_8762_22890a963abc = { getGuid: function() { return "5b25af20-114a-4a3d-8762-22890a963abc"; } }; })();
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-resultsagainst",
                        callback: (accordion, e) => {
                            const $tabmenu = accordion.$Container.find(".tabmenu.control-cs:not(.results-against-tabmenu)");
                            accordion.SetContentSticky($tabmenu);
                            if (ResultsAgainstSection.IsEmpty(accordion))
                                return;
                            ResultsAgainstSection.SetContentV2(accordion);
                            accordion.$Control.offon(`click.${accordion.UniqueInstanceId}`, ".tabmenu.control-cs .tab-menu-item", (e) => {
                                const $item = $(e.currentTarget);
                                const timePeriod = $item.attr("id");
                                const isHighlighted = $item.hasClass("is-highlighted");
                                if (!isHighlighted) {
                                    $item.addClass("is-highlighted");
                                    $item.siblings().removeClass("is-highlighted");
                                    switch (timePeriod) {
                                        case "all":
                                            accordion.$Content
                                                .find(".results-against__body .all-time")
                                                .css({ display: "" });
                                            accordion.$Content
                                                .find(".results-against__body .recent")
                                                .css({ display: "none" });
                                            break;
                                        case "last-year":
                                            accordion.$Content
                                                .find(".results-against__body .recent")
                                                .css({ display: "" });
                                            accordion.$Content
                                                .find(".results-against__body .all-time")
                                                .css({ display: "none" });
                                            break;
                                        default:
                                    }
                                }
                            });
                        },
                    });
                    let ResultsAgainstSection;
                    (function (ResultsAgainstSection) {
                        function IsEmpty(accordion) {
                            var _a;
                            const $emptyStateElement = accordion.$Content.find(`#ResultsAgainstSectionViewModelNoData-${accordion.ContentId}`);
                            if ($emptyStateElement.length) {
                                const $gameTypeNameInput = accordion.$Content.find(`#ResultsAgainstSectionViewModelGameTypeName-${accordion.ContentId}`);
                                const gameTypeName = (_a = $gameTypeNameInput.val()) !== null && _a !== void 0 ? _a : "";
                                if (gameTypeName.trim() === "") {
                                    $emptyStateElement.text(JSRess.These2OpponentsHaveNeverPlayedAgainstEachOther);
                                }
                                else {
                                    $emptyStateElement.html(CS.Helper.formatString(JSRess.These2OpponentsHaveNeverPlayedAgainstEachOtherInX, gameTypeName));
                                }
                                return true;
                            }
                            return false;
                        }
                        ResultsAgainstSection.IsEmpty = IsEmpty;
                        function SetContentV2(accordion) {
                            const $statCanvas = accordion.$Content.find(".stat-container canvas");
                            const colors = CS.Helper.DataVisualizationHelper.getColors(2);
                            const width = 1200;
                            const marginTop = 0;
                            const marginRight = 0;
                            const marginBottom = 0;
                            const marginLeft = 0;
                            if ($statCanvas.length) {
                                $statCanvas.each((index, canvas) => {
                                    const $canvas = $(canvas);
                                    const $chartContainer = $canvas.closest(".canvas-container");
                                    const $statContainer = $canvas.closest(".stat-container");
                                    let chartContainerId = $chartContainer.attr("id");
                                    if (!chartContainerId) {
                                        chartContainerId = CS.Helper.generateRandomId();
                                        $chartContainer.attr("id", chartContainerId);
                                    }
                                    $canvas.css({ display: "none" });
                                    $chartContainer.addClass("stat-container__chart");
                                    const _valueA = $statContainer.attr("data-chart-value-a");
                                    const _valueB = $statContainer.attr("data-chart-value-b");
                                    if (!_valueA || !_valueB)
                                        return;
                                    const valueA = Number(_valueA.replace(",", "."));
                                    const valueB = Number(_valueB.replace(",", "."));
                                    const datapoints = [
                                        {
                                            stackId: "0",
                                            seriesId: "A",
                                            value: valueA,
                                            isStacked: false,
                                        },
                                        {
                                            stackId: "0",
                                            seriesId: "B",
                                            value: valueB,
                                            isStacked: true,
                                        },
                                    ];
                                    setTimeout(() => {
                                        const comparedValueBarChart = new CS.Controls.ComparedValueBarChart({
                                            colors: colors,
                                            containerElementId: chartContainerId,
                                            datapoints: datapoints,
                                        });
                                        comparedValueBarChart
                                            .init()
                                            .then(() => {
                                            CS.Helper.log("ComparedResults", "ComparedValueBarChart.init() done");
                                        })
                                            .catch((error) => {
                                            console.error("ComparedValueBarChart.init() error", error);
                                        });
                                    }, index * 10);
                                });
                            }
                        }
                        ResultsAgainstSection.SetContentV2 = SetContentV2;
                    })(ResultsAgainstSection = WallSections.ResultsAgainstSection || (WallSections.ResultsAgainstSection = {}));
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=results-against.js.map
